import apiClient from '@/lib/axios'

export const getUserFolders = async (
  params: GetFolderParams
): Promise<GetFolderResponse> => {
  const queryParams = new URLSearchParams(
    Object.entries(params)
      .filter(([_, value]) => value !== undefined || value !== '')
      .map(([key, value]) => [key, value.toString()])
  ).toString()
  const response = await apiClient.get(`/folders?${queryParams}`)
  return response.data
}

export const getUserFolderById = async (
  folderId: string
): Promise<Folder> => {
  const response = await apiClient.get(`/folders/${folderId}`)
  return response.data
}

export const createUserFolder = async (body: CreateFolderParams) => {
  const response = await apiClient.post(`/folders`, {
    ...body,
  })
  return response.data
}

export const deleteUserFolder = async (organization_id: string) => {
  const response = await apiClient.delete(`/folders/${organization_id}`)
  return response.data
}

export const updateUserFolder = async (folderId: string, body: CreateFolderParams) => {
  const response = await apiClient.patch(`/folders/${folderId}`, {
    ...body,
  })
  return response.data
}

export const deleteFoldersByIds = async (body: DeleteFoldersParams) => {
    const response = await apiClient.delete(`/folders`, {
        data: {
            ...body
        } 
    });
    return response.data;
}

export const getAllFolders = async (): Promise<GetAllFoldersResponse> => {
  const response = await apiClient.get(`/folders/all-folders`)
  return response.data
}